import { render } from "./ui-button.vue?vue&type=template&id=5f9dc6e0&scoped=true"
import script from "./ui-button.vue?vue&type=script&lang=js"
export * from "./ui-button.vue?vue&type=script&lang=js"

import "./ui-button.vue?vue&type=style&index=0&id=5f9dc6e0&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9dc6e0"],['__file',"src/components/ui/ui-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f9dc6e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f9dc6e0', __exports__)) {
    api.reload('5f9dc6e0', __exports__)
  }
  
  module.hot.accept("./ui-button.vue?vue&type=template&id=5f9dc6e0&scoped=true", () => {
    api.rerender('5f9dc6e0', render)
  })

}


export default __exports__